import * as React from 'react';

import { EngineRenderers } from '@websky/core/src/renderProps';
import { Currency } from '@websky/core/src/enums';
import CurrencyWarning from '@websky/core/src/PaymentForm/components/CurrencyWarning/CurrencyWarning';
import css from './CurrencyWarning.css';
import { Warning } from '@websky/core/src/Icons';

const CheckoutCurrencyWarning: EngineRenderers['CheckoutCurrencyWarning'] = props => {
	if (props.total.amount === 0 || props.total.currency === Currency.RUB) {
		return null;
	}

	return (
		<div className={css.warning}>
			<span className={css.icon}>{Warning}</span>
			<CurrencyWarning price={props.total} />
		</div>
	);
};

export default CheckoutCurrencyWarning;
